import ManageLicense from '../License/ManageLicense';
import DataSourceGeneralSettings from './DataSourceGeneralSettings';
import ScriptSettings from './ScriptSettings';
import WebsiteSettings from './WebsiteSettings';
import PrivacySettings from './PrivacySettings';
import TagManager from './TagManager/TagManager';

const routes = [
  {
    path: 'general',
    label: 'General',
    component: DataSourceGeneralSettings,
  },
  {
    path: 'website',
    label: 'Website',
    component: WebsiteSettings,
  },
  {
    path: 'script',
    label: 'Script',
    component: ScriptSettings,
  },
  {
    path: 'tag-manager',
    label: 'Tag manager',
    component: TagManager,
  },
  {
    path: 'privacy',
    label: 'Privacy & cookies',
    component: PrivacySettings,
  },
  {
    path: 'license',
    label: 'License & usage',
    component: ManageLicense,
  },
];

export default routes;
